// Central content — edit here for site changes
export const SITE = {
  brand: "ORENTIS",
  tagline: ["Strategy.", "Scale.", "Success."],
  contact: {
    email: "dinkar.chopra@orentisconsulting.in",
    phone: "+91 98030 33678",
    phoneRaw: "+919803033678",
    linkedin: "https://www.linkedin.com/in/dinkar-chopra",
    linkedinLabel: "linkedin.com/in/dinkar-chopra",
  },
  stats: [
    { value: "45", suffix: "+", label: "Brands Built" },
    { value: "12", suffix: "", label: "Categories Served" },
    { value: "120", suffix: "+", label: "Mandates Delivered" },
  ],
  manifesto: [
    {
      no: "01",
      title: "Identify the Need",
      body: "Every brand begins with a question no market yet answers. We diagnose with rigor, sitting inside the founder's ambition and the customer's unspoken tension.",
    },
    {
      no: "02",
      title: "Build the Story",
      body: "Strategy is a story with a spine. We build positioning, narrative and identity systems that behave like companies. Coherent, memorable, unmistakable.",
    },
    {
      no: "03",
      title: "Execute with Precision",
      body: "Ideas that never ship don't count. We orchestrate go to market, from SKUs and shelves to search results and social feeds, with operating discipline.",
    },
    {
      no: "04",
      title: "Scale into Legacy",
      body: "We stay past the launch. Distribution, franchise, community, coaching. The compounding levers that turn brands into institutions.",
    },
  ],
  services: [
    {
      key: "brand",
      no: "01",
      title: "Brand Strategy",
      lead: "Positioning, guidelines, brand books, media planning.",
      items: ["Brand Positioning", "Brand Guidelines", "Brand Book", "Media Planning"],
    },
    {
      key: "gtm",
      no: "02",
      title: "Go To Market",
      lead: "From white space to first sale. A launch calibrated to win.",
      items: ["Category Entry", "Pricing Architecture", "Launch Playbook", "Channel Mix"],
    },
    {
      key: "franchise",
      no: "03",
      title: "Franchise Development",
      lead: "Unit economics, franchisee acquisition, playbooks.",
      items: ["FDD Design", "Territory Mapping", "Franchisee Onboarding", "Royalty Modeling"],
    },
    {
      key: "omni",
      no: "04",
      title: "Omni Channel Distribution",
      lead: "Every shelf. Every screen. One narrative.",
      items: [
        "Marketplace",
        "Website / D2C",
        "Quick Commerce",
        "Aggregators",
        "EBO",
        "Franchise",
        "Modern Trade",
        "General Trade",
        "Wholesale",
        "Government",
      ],
    },
    {
      key: "social",
      no: "05",
      title: "Social Media Management",
      lead: "Editorial calendars, creators, and always on brand voice.",
      items: ["Creative Direction", "Content Ops", "Creator Networks", "Reporting"],
    },
    {
      key: "community",
      no: "06",
      title: "Community Development",
      lead: "Owned audiences that compound over years, not campaigns.",
      items: ["Community Design", "Advocacy Programs", "Events & IP", "Loyalty"],
    },
    {
      key: "coaching",
      no: "07",
      title: "Executive Coaching",
      lead: "Sharpening founders and leadership teams for the next arc.",
      items: ["Founder Sparring", "Leadership Offsites", "Board Prep", "Personal Brand"],
    },
    {
      key: "sop",
      no: "08",
      title: "SOP · Planning & Execution",
      lead: "The unglamorous system that lets great brands scale.",
      items: ["Process Design", "Playbooks", "KPI Frameworks", "Change Management"],
    },
    {
      key: "sales",
      no: "09",
      title: "Sales · Planning & Execution",
      lead: "Pipelines, incentives and forecasting that hold.",
      items: ["Sales Structure", "Incentive Design", "Forecasting", "Field Enablement"],
    },
    {
      key: "invest",
      no: "10",
      title: "Investment & Funding",
      lead: "Investor readiness, capital strategy, and warm introductions.",
      items: ["Capital Strategy", "Investor Readiness", "Data Room Craft", "Investor Introductions"],
    },
    {
      key: "pitch",
      no: "11",
      title: "Pitch Deck Guidance",
      lead: "Narrative, numbers and design. Engineered to raise.",
      items: ["Story Architecture", "Financial Narrative", "Deck Design", "Rehearsal & Q&A"],
    },
  ],
  clients: [
    { name: "Gillette", logo: "/logos/gillette-logo_brandlogos.net_wfrnp.png" },
    { name: "Gillette 7 O'Clock", logo: "/logos/7-0_clock.webp" },
    { name: "Presto", logo: "/logos/gillette-presto3-logo_2x.png" },
    { name: "Wilkinson Sword", logo: "/logos/wilkinson-sword-identity-designed-by-bandb-studio-1.webp" },
    { name: "Braun", logo: "/logos/braun.jpg" },
    { name: "Cargill", logo: "/logos/cargill.png" },
    { name: "Godfrey Phillips", logo: "/logos/gpi.png" },
    { name: "Marlboro", logo: "/logos/marlboro.png" },
    { name: "Geep Batteries", logo: "/logos/geep.jpeg" },
    { name: "Four Square", logo: "/logos/four_square.jpeg" },
    { name: "Red & White", logo: "/logos/redwhite.jpeg" },
    { name: "Cavenders", logo: "/logos/cavenders.jpeg" },
    { name: "NatureFresh", logo: "/logos/naturefresh.jpeg" },
    { name: "Gemini Refined Oil", logo: "/logos/gemini.jpeg" },
    { name: "Rath", logo: "/logos/rath.jpeg" },
    { name: "Sunflower", logo: "/logos/sunflower.jpeg" },
    { name: "Polariser", logo: "/logos/polariser.png" },
    { name: "Sweekar", logo: "/logos/sweekar.jpeg" },
    { name: "Zorba", logo: "/logos/zorba.jpeg" },
    { name: "Leonardo", logo: "/logos/lenardo.jpeg" },
    { name: "ICICI Prudential", logo: "/logos/icici.jpeg" },
    { name: "Aditya Birla Capital", logo: "/logos/absli.jpeg" },
    { name: "PNB MetLife", logo: "/logos/pnbmetlife.png" },
    { name: "La Mont Perfume", logo: "/logos/la_mont.png" },
    { name: "Cassidy Cosmetics", logo: "/logos/cassidy.jpeg" },
    { name: "Atal Incubation Centre", logo: "/logos/atal_incubation.png" },
    { name: "Startup Odisha", logo: "/logos/startup_odisha.jpeg" },
    { name: "Mentor Cart", logo: "/logos/mentorkart.png" },
    { name: "WheelsEye", logo: "/logos/wheelseye.jpeg" },
    { name: "Freeco", logo: "/logos/freeco.jpeg" },
    { name: "Easy Knowledge", logo: "/logos/easyknowledge.jpeg" },
  ],
};
